const DOC_TYPE_DISPLAY: Record<string, string> = {
    sad: "SAD",
    pod: "POD",
    bl: "BL",
    awb: "AWB",
    sad_imcs: "SAD / IMCS",
    sad_imcs_entry_summary_customs_declaration: "SAD / IMCS",
    waybill_bill_of_lading: "Bill of Lading",
    proof_of_delivery: "Proof of Delivery",
    commercial_invoice: "Commercial Invoice",
    invoices_di_vendita: "Commercial Invoice",
    packing_list: "Packing List",
    certificate_of_origin: "Certificate of Origin",
    phytosanitary_certificate: "Phytosanitary Certificate",
    booking_confirmation: "Booking Confirmation",
    delivery_order: "Delivery Order",
};

export function formatDocumentType(raw: string): string {
    const lower = raw.toLowerCase();
    if (DOC_TYPE_DISPLAY[lower]) return DOC_TYPE_DISPLAY[lower];
    return raw.replace(/_/g, " ").replace(/\b\w/g, c => c.toUpperCase());
}
